import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { useState as s, useEffect as x } from "react";
import { getIndexFromTimeString as p, transformTimeToReadable as A, PICKER_TIMES as D } from "@givebutter/util";
import { Root as R, Trigger as U, Value as j, Content as P, Item as u, ItemText as I } from "../single-select/SingleSelect.js";
import { DateTime as _ } from "luxon";
const i = "none", M = ({
  cutoffUntil: l,
  cutoffAfter: a,
  value: n = i,
  onValueChange: c,
  timezoneAbbr: S = _.now().offsetNameShort,
  disabled: T,
  ...g
}) => {
  const [f, m] = s(n), [d, C] = s(), [h, b] = s(), E = f === i;
  return x(() => {
    n && m(n);
  }, [n]), x(() => {
    const e = p(a), o = p(l);
    b(e), C(o);
  }, [a, l]), /* @__PURE__ */ r(
    R,
    {
      value: n,
      onValueChange: (e) => {
        e !== i && (c ? c(e) : m(e));
      },
      ...g,
      children: [
        /* @__PURE__ */ t(U, { "aria-label": "Select time", disabled: T, children: /* @__PURE__ */ t(j, { placeholder: "Select time", children: E ? void 0 : /* @__PURE__ */ r("span", { className: "flex flex-nowrap items-center gap-1 whitespace-nowrap text-base font-normal", children: [
          A(f),
          /* @__PURE__ */ r("span", { className: "text-xs font-medium leading-none text-gray-500", children: [
            "(",
            S,
            ")"
          ] })
        ] }) }) }),
        /* @__PURE__ */ r(P, { children: [
          /* @__PURE__ */ t(u, { value: i, disabled: !0, children: /* @__PURE__ */ t(I, { children: "Select time" }) }),
          D.map((e, o) => {
            const N = d ? d > o : !1, w = h ? h < o : !1, V = N || w;
            return /* @__PURE__ */ t(u, { value: e.time, disabled: V, children: /* @__PURE__ */ t(I, { children: e.label }) }, e.time);
          })
        ] })
      ]
    }
  );
};
export {
  M as TimePicker
};
